import { defineComponent as _defineComponent } from 'vue';
import { DialogDescription } from 'reka-ui';
import { computed } from 'vue';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DialogDescription',
    props: {
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const delegatedProps = computed(() => {
            const { class: _, ...delegated } = props;
            return delegated;
        });
        const __returned__ = { props, delegatedProps, get DialogDescription() { return DialogDescription; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
